<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/2gKblu/tc-custom/9781416565673.jpg?1730494019983" alt="This image is the cover for the book Essential Survival Guide to Living on Your Own"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Essential Survival Guide to Living on Your Own
      </h1>
      <p class="bookDescription body article font2">
        <b><br/> Are you ready to strike out on your own? <br/></b><br/> In today's competitive world, you need all the help you can get. <i>Essential Survival Guide</i> provides you with how-to and hands-on instruction to make life less of a chore and more of an adventure. <br/><br/> Sections include: <br/><b>Getting through the Day</b>: Setting goals, organization, and understanding essential documents<b>Money, Money, Money</b>: Learning about banking, credit, and debt; understanding taxes<b>Getting Your Own Place</b>: Finding the right roommates, resolving conflicts, and purchasing a home<b>Wheels</b>: Buying a car and purchasing car insurance; maintaining your new or used carAnd much more!<br/> Independent living is only a read away. Full of practical advice in an easy-to-use format, this book covers everything from sorting laundry (yes, you have to sort) to choosing a church. The concise chapters and quick tips will make the learning fun and easy to apply.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sharon B. Siepel
      </h2>
      
      <p class="authorDescription body article">Sharon Siepel is a mother of four and an aunt to dozens. She has a degree in speech communications from Iowa State University, where she was awarded a writing scholarship. She is a&#160;freelance writer and the&#160;author of<I>&#160;Essential Survival Guide to Living on Your Own</I>.&#160;<BR><BR>&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Howard Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?82502626